import state from './state';
import * as getters from './getters';
import * as mutations from './mutations';

const aggregationSeries = {
    namespaced: true,
    actions: {},
    getters,
    mutations,
    state
}

export default aggregationSeries;
